import { ReactNode } from "react";
import { Configure, InstantSearch as InstantSearchPrimitive } from "react-instantsearch";
import { IndexNameProvider } from "../search-results/components/IndexNameProvider";
import { autosuggestSearchClient, searchIndexes } from "../search-shared/client";

export default function InstantSearch({ children } : { children: ReactNode }) {
  const { products_autocomplete_hits_per_page = 6 } = window?.algoliaShopify?.config || {};

  return (
    <IndexNameProvider>
      <InstantSearchPrimitive
        searchClient={autosuggestSearchClient}
        indexName={searchIndexes.RECOMMENDED_PRODUCTS}
        insights={true}
        future={{ preserveSharedStateOnUnmount: true }}
      >
        <Configure
          distinct={true}
          hitsPerPage={products_autocomplete_hits_per_page}
        />
          {children}
      </InstantSearchPrimitive>
    </IndexNameProvider>
  );
}